import { createFeatureSelector, createSelector } from '@ngrx/store';

import { PartnerState } from '@admin/src/core/models/partner-state.interface';

export const selectPartnerState = createFeatureSelector<PartnerState>('partner');

export const selectPartnersFilter = createSelector(selectPartnerState, state => state.partnersList.filter);

export const selectPartnersPageSize = createSelector(selectPartnerState, state => state.partnersList.pageSize);
export const selectPartnersContinuationToken = createSelector(selectPartnerState, state => state.partnersList.continuationToken);
export const selectPartnersList = createSelector(selectPartnerState, state => state.partnersList.data);
export const selectPartnersListLoading = createSelector(selectPartnerState, state => state.partnersList.loading);

export const selectCurrentPartner = createSelector(selectPartnerState, state => state.currentPartner.data);
export const selectCurrentPartnerLoading = createSelector(selectPartnerState, state => state.currentPartner.loading);

// Location Selectors
export const selectLocationsFilter = createSelector(selectPartnerState, state => state.locationsList.filter);

export const selectLocationsPageSize = createSelector(selectPartnerState, state => state.locationsList.pageSize);
export const selectLocationsContinuationToken = createSelector(selectPartnerState, state => state.locationsList.continuationToken);
export const selectLocationsList = createSelector(selectPartnerState, state => state.locationsList.data);
export const selectLocationsListLoading = createSelector(selectPartnerState, state => state.locationsList.loading);

export const selectCurrentLocation = createSelector(selectPartnerState, state => state.currentLocation.data);
export const selectCurrentLocationLoading = createSelector(selectPartnerState, state => state.currentLocation.loading);

// Doctor Selectors
export const selectDoctorsFilter = createSelector(selectPartnerState, state => state.doctorsList.filter);

export const selectDoctorsPageSize = createSelector(selectPartnerState, state => state.doctorsList.pageSize);
export const selectDoctorsContinuationToken = createSelector(selectPartnerState, state => state.doctorsList.continuationToken);
export const selectDoctorsList = createSelector(selectPartnerState, state => state.doctorsList.data);
export const selectDoctorsListLoading = createSelector(selectPartnerState, state => state.doctorsList.loading);

export const selectCurrentDoctor = createSelector(selectPartnerState, state => state.currentDoctor.data);
export const selectCurrentDoctorLoading = createSelector(selectPartnerState, state => state.currentDoctor.loading);

// Offering Selectors
export const selectOfferingsFilter = createSelector(selectPartnerState, state => state.offeringsList.filter);

export const selectOfferingsPageSize = createSelector(selectPartnerState, state => state.offeringsList.pageSize);
export const selectOfferingsContinuationToken = createSelector(selectPartnerState, state => state.offeringsList.continuationToken);
export const selectOfferingsList = createSelector(selectPartnerState, state => state.offeringsList.data);
export const selectOfferingsListLoading = createSelector(selectPartnerState, state => state.offeringsList.loading);

export const selectCurrentOffering = createSelector(selectPartnerState, state => state.currentOffering.data);
export const selectCurrentOfferingLoading = createSelector(selectPartnerState, state => state.currentOffering.loading);
